import { Component, OnInit, ViewChild } from '@angular/core';
import { Germplasm } from '../../entities/germplasm/germplasm.model';
import { GermplasmSearchRequest } from '../../entities/germplasm/germplasm-search-request.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilterComponent, FilterType } from '../../shared/column-filter/column-filter.component';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { HttpResponse } from '@angular/common/http';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GermplasmTreeTableComponent } from '../../shared/tree/germplasm/germplasm-tree-table.component';
import { StudyTreeComponent } from '../../shared/tree/study/study-tree.component';
import { MatchType } from '../../shared/column-filter/column-filter-text-with-match-options-component';
import { PedigreeType } from '../../shared/column-filter/column-filter-pedigree-options-component';
import { SORT_PREDICATE_NONE } from '.././germplasm-search-resolve-paging-params';
import { ModalConfirmComponent } from '../../shared/modal/modal-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { ParamContext } from '../../shared/service/param.context';
import { ColumnLabels } from '../germplasm-search.component';
import { GermplasmDetailsUrlService } from '../../shared/germplasm/service/germplasm-details.url.service';
import { SearchResult } from '../../shared/search-result.model';
import { VIEW_NAMES_PERMISSION, VIEW_PEDIGREE_INFORMATION_PERMISSION } from '../../shared/auth/permissions';
import { Principal } from '../../shared';
import { MAX_NAME_DISPLAY_SIZE } from '../../app.constants';
import { preventDefaultOnShiftKey } from '../../field-management/utils';

@Component({
    selector: 'jhi-germplasm-selector',
    templateUrl: './germplasm-selector.component.html'
})
export class GermplasmSelectorComponent implements OnInit {

    VIEW_PEDIGREE_INFORMATION_PERMISSION = VIEW_PEDIGREE_INFORMATION_PERMISSION;
    VIEW_NAMES_PERMISSION = VIEW_NAMES_PERMISSION;

    ColumnLabels = ColumnLabels;

    @ViewChild('colVisPopOver', { static: true }) public colVisPopOver: NgbPopover;
    eventSubscriber: Subscription;
    germplasmList: Germplasm[];
    error: any;
    currentSearch: string;
    routeData: any;
    links: any;
    filteredItems: any;
    itemsPerPage: any = 10;
    page: any = 1;
    predicate: any;
    previousPage: any;
    reverse: boolean;
    resultSearch: SearchResult;

    isLoading: boolean;
    selectMultiple: any = false;

    germplasmSearchRequest = new GermplasmSearchRequest();
    germplasmFilters: any;
    germplasmHiddenColumns = {};

    selectedItems: any[] = [];
    isSelectAllPages = false;

    MAX_NAME_DISPLAY_SIZE = MAX_NAME_DISPLAY_SIZE;

    lastClickIndex: any;

    NAMES_RELATED_FILTERS = ['nameFilter', 'femaleParentName', 'maleParentName', 'groupSourceName', 'immediateSourceName', 'nameTypes'];
    PEDIGREE_RELATED_FILTERS = ['femaleParentName', 'maleParentName', 'groupSourceName', 'immediateSourceName', 'includePedigree'];
    private static getInitialFilters() {
        return [
            {
                key: 'nameFilter', name: 'column-filter.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH, default: true
            },
            { key: 'germplasmUUID', name: 'column-filter.germplasm.uuid', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            { key: 'gids', name: 'column-filter.gid', placeholder: 'column-filter.comma.separated.values.placeholder', type: FilterType.LIST, default: true },
            {
                key: 'gidRange', name: 'column-filter.gid.range', type: FilterType.NUMBER_RANGE,
                fromKey: 'gidFrom',
                toKey: 'gidTo',
                transform(req) {
                    ColumnFilterComponent.transformNumberRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reset(req) {
                    ColumnFilterComponent.resetRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reload(req) {
                    this.from = req[this.fromKey];
                    this.to = req[this.toKey];
                }
            },
            { key: 'groupId', name: 'column-filter.group.id', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            { key: 'sampleUID', name: 'column-filter.sample.id', placeholder: 'column-filter.match.text.placeholder', type: FilterType.TEXT },
            {
                key: 'germplasmListIds', name: 'column-filter.germplasm.list', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(GermplasmTreeTableComponent as Component, { size: 'xl', backdrop: 'static' })
                            .result.then((germplasmLists) => {
                                if (germplasmLists && germplasmLists.length > 0) {
                                    this.value = germplasmLists.map((list) => list.name);
                                    request[this.key] = germplasmLists.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            { key: 'stockId', name: 'column-filter.stock.id', placeholder: 'column-filter.starts.with.placeholder', type: FilterType.TEXT },
            { key: 'locationOfOrigin', name: 'column-filter.location.of.origin', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            { key: 'locationOfUse', name: 'column-filter.location.of.use', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            {
                key: 'studyOfUseIds', name: 'column-filter.study.of.use', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'studyOfOriginIds', name: 'column-filter.study.of.origin', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'plantingStudyIds', name: 'column-filter.study.of.lot.use', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            {
                key: 'harvestingStudyIds', name: 'column-filter.study.of.lot.origin', type: FilterType.MODAL,
                open(modal, request) {
                    return new Promise((resolve) => {
                        modal.open(StudyTreeComponent as Component, { modalDialogClass: 'modal-xs', backdrop: 'static' })
                            .result.then((studyIds) => {
                                if (studyIds) {
                                    this.value = studyIds.map((list) => list.name);
                                    request[this.key] = studyIds.map((list) => list.id);
                                }
                                resolve(undefined);
                            }, () => {
                            });
                    });
                }
            },
            { key: 'reference', name: 'column-filter.reference', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            { key: 'breedingMethodName', name: 'column-filter.breeding.method.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT },
            {
                key: 'germplasmDate', name: 'column-filter.germplasm.date', type: FilterType.DATE,
                fromKey: 'germplasmDateFrom',
                toKey: 'germplasmDateTo',
                transform(req) {
                    ColumnFilterComponent.transformDateFilter(this, req, this.fromKey, this.toKey);
                },
                reset(req) {
                    ColumnFilterComponent.resetRangeFilter(this, req, this.fromKey, this.toKey);
                },
                reload(req) {
                    this.from = req[this.fromKey];
                    this.to = req[this.toKey];
                }
            },
            {
                key: 'femaleParentName', name: 'column-filter.cross.female.parent.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'maleParentName', name: 'column-filter.cross.male.parent.name', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'groupSourceName', name: 'column-filter.group.source.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'immediateSourceName', name: 'column-filter.immediate.source.name', placeholder: 'column-filter.contains.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            { key: 'withInventoryOnly', name: 'column-filter.with.inventory.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withRawObservationsOnly', name: 'column-filter.with.observations.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withSampleOnly', name: 'column-filter.with.sample.only', type: FilterType.BOOLEAN, value: true },
            { key: 'withAnalyzedDataOnly', name: 'column-filter.with.analyzed.data.only', type: FilterType.BOOLEAN, value: true },
            { key: 'inProgramListOnly', name: 'column-filter.in.program.list.only', type: FilterType.BOOLEAN, value: true },
            { key: 'includeGroupMembers', name: 'column-filter.include.group.members', type: FilterType.BOOLEAN, value: true },
            {
                key: 'includePedigree', name: 'column-filter.include.pedigree', type: FilterType.PEDIGREE_OPTIONS,
                pedigreeType: PedigreeType.GENERATIVE,
                value: 1, // Generation Level
                transform(req) {
                    ColumnFilterComponent.transformPedigreeOptionsFilter(this, req);
                },
                options: Promise.resolve([{
                    id: PedigreeType.GENERATIVE, name: 'column-filter.pedigree.option.generative'
                }, {
                    id: PedigreeType.DERIVATIVE, name: 'column-filter.pedigree.option.derivative'
                }, {
                    id: PedigreeType.BOTH, name: 'column-filter.pedigree.option.both'
                }])
            },
            {
                key: 'attributes', name: 'column-filter.attributes', placeholder: 'column-filter.attributes.placeholder', type: FilterType.ATTRIBUTES, attributes: [],
                transform(req) {
                    ColumnFilterComponent.transformAttributesFilter(this, req);
                },
                reset(req) {
                    ColumnFilterComponent.resetAttributesFilter(this, req);
                },
            },
            {
                key: 'nameTypes', name: 'column-filter.name.types', placeholder: 'column-filter.name.types.placeholder', type: FilterType.NAME_TYPES, nameTypes: [],
                transform(req) {
                    ColumnFilterComponent.transformNameTypesFilter(this, req);
                },
                reset(req) {
                    ColumnFilterComponent.resetNameTypesFilter(this, req);
                },
            },
            {
                key: 'externalReferenceSource', name: 'column-filter.external.reference.source', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            },
            {
                key: 'externalReferenceId', name: 'column-filter.external.reference.id', placeholder: 'column-filter.search.text.placeholder', type: FilterType.TEXT_WITH_MATCH_OPTIONS,
                matchType: MatchType.STARTSWITH
            }
        ];
    }

    get request() {
        return this.germplasmSearchRequest;
    }

    set request(request) {
        this.germplasmSearchRequest = request;
    }

    get filters() {
        return this.germplasmFilters;
    }

    set filters(filters) {
        this.germplasmFilters = filters;
    }

    get hiddenColumns() {
        return this.germplasmHiddenColumns;
    }

    set hiddenColumns(hiddenColumns) {
        this.germplasmHiddenColumns = hiddenColumns;
    }

    constructor(private activatedRoute: ActivatedRoute,
                private eventManager: JhiEventManager,
                private germplasmService: GermplasmService,
                private router: Router,
                private modal: NgbModal,
                private translateService: TranslateService,
                private paramContext: ParamContext,
                public germplasmDetailsUrlService: GermplasmDetailsUrlService,
                private languangeService: JhiLanguageService,
                private principal: Principal) {
        const currentLang = this.languangeService.getCurrentLanguage();
        this.languangeService.changeLanguage(currentLang);

        this.predicate = '';
        this.routeData = this.activatedRoute.data.subscribe((data) => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
        });
        this.paramContext.readParams();
        const queryParams = this.activatedRoute.snapshot.queryParams;
        const selectMultipleParamString = queryParams.selectMultiple;
        this.selectMultiple = selectMultipleParamString === undefined || (selectMultipleParamString.toString().trim().toLowerCase() === 'true');
        this.currentSearch = this.activatedRoute.snapshot && this.activatedRoute.snapshot.params['search'] ?
            this.activatedRoute.snapshot.params['search'] : '';

        if (!this.filters) {
            this.filters = GermplasmSelectorComponent.getInitialFilters();
            if (!this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION)) {
                this.filters = this.filters.filter((filter) => {
                    return !this.NAMES_RELATED_FILTERS.includes(filter);
                });
            }
            if (!this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSION)) {
                this.filters = this.filters.filter((filter) => {
                    return !this.PEDIGREE_RELATED_FILTERS.includes(filter);
                });
            }
            this.eventManager.broadcast({ name: 'reloadFilters', content: { filters: this.filters, request: this.request } });
        }
        this.resultSearch = new SearchResult('');

    }

    search(request: GermplasmSearchRequest): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!this.resultSearch.searchResultDbId) {
                this.germplasmService.search(request).subscribe((response) => {
                    this.resultSearch.searchResultDbId = response;
                    resolve(this.resultSearch.searchResultDbId);
                }, (error) => reject(error));
                this.page = 1;
            } else {
                resolve(this.resultSearch.searchResultDbId);
            }
        });
    }

    loadAll(request: GermplasmSearchRequest, successCallback?: () => void) {
        this.isLoading = true;
        this.search(request).then((searchId) => {
            this.germplasmService.getSearchResults(
                this.addSortParam({
                    searchRequestId: searchId,
                    page: this.page - 1,
                    size: this.itemsPerPage
                })
            ).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(
                (res: HttpResponse<Germplasm[]>) => this.onSuccess(res.body, res.headers, successCallback));
        });
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['./'], {
            queryParams:
                this.addSortParam({
                    page: this.page,
                    size: this.itemsPerPage,
                    search: this.currentSearch,
                }), relativeTo: this.activatedRoute
        });
        this.loadAll(this.request);
    }

    ngOnInit() {
        this.loadAll(this.request);
        this.registerChangeInGermplasm();
        this.request.addedColumnsPropertyIds = [];
        this.hiddenColumns[ColumnLabels['GERMPLASM UUID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP ID']] = true;
        this.hiddenColumns[ColumnLabels['GERMPLASM DATE']] = true;
        this.hiddenColumns[ColumnLabels['METHOD ABBREV']] = true;
        this.hiddenColumns[ColumnLabels['METHOD NUMBER']] = true;
        this.hiddenColumns[ColumnLabels['METHOD GROUP']] = true;
        this.hiddenColumns[ColumnLabels['PREFERRED NAME']] = true;
        this.hiddenColumns[ColumnLabels['PREFERRED ID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP SOURCE GID']] = true;
        this.hiddenColumns[ColumnLabels['GROUP SOURCE']] = true;
        this.hiddenColumns[ColumnLabels['IMMEDIATE SOURCE GID']] = true;
        this.hiddenColumns[ColumnLabels['IMMEDIATE SOURCE']] = true;
        this.hiddenColumns[ColumnLabels['FGID']] = true;
        this.hiddenColumns[ColumnLabels['CROSS-FEMALE PREFERRED NAME']] = true;
        this.hiddenColumns[ColumnLabels['MGID']] = true;
        this.hiddenColumns[ColumnLabels['CROSS-MALE PREFERRED NAME']] = true;
    }

    addSortParam(params) {
        const sort = this.predicate && this.predicate !== SORT_PREDICATE_NONE ? {
            sort: [this.getSort()]
        } : {};
        return Object.assign(params, sort);
    }

    getSort() {
        if (!this.predicate) {
            return '';
        }
        return [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    }

    preSortCheck() {
        const isAddedColumn = this.request.addedColumnsPropertyIds.some((col) => col === this.predicate);
        const isHidden = this.hiddenColumns[this.predicate];
        if (isHidden || !ColumnLabels[this.predicate] && !isAddedColumn) {
            this.clearSort();
        }
    }

    clearSort() {
        this.predicate = SORT_PREDICATE_NONE;
        this.reverse = false;
    }

    onClearSort($event) {
        $event.preventDefault();
        this.clearSort();
        this.transition();
    }

    /**
     * Sorting limits the response size, so it's important to reset
     */
    sort() {
        this.page = 1;
        this.transition();
    }

    trackId(index: number, item: Germplasm) {
        return item.gid;
    }

    registerChangeInGermplasm() {
        this.eventSubscriber = this.eventManager.subscribe('columnFiltersChanged', (event) => {

            this.preSortCheck();

            if (this.isExpensiveFilter()) {
                const confirmModalRef = this.modal.open(ModalConfirmComponent as Component);
                confirmModalRef.componentInstance.title = this.translateService.instant('search-germplasm.performance-warning.title');
                let message = this.translateService.instant('search-germplasm.performance-warning.text');
                message += this.getExpensiveFilterWarningList();
                confirmModalRef.componentInstance.message = message;
                confirmModalRef.result.then(() => {
                    this.resetTable();
                }, () => confirmModalRef.dismiss());

            } else {
                this.resetTable();
            }

        });
    }

    isExpensiveFilter() {
        return this.request && this.hasNameContainsFilters();
    }

    getExpensiveFilterWarningList() {
        let list = '';
        if (this.hasNameContainsFilters()) {
            list += '<li>name contains</li>';
        }
        return list;
    }

    private hasNameContainsFilters() {
        return this.request.nameFilter && this.request.nameFilter.type === MatchType.CONTAINS
            || this.request.femaleParentName && this.request.femaleParentName.type === MatchType.CONTAINS
            || this.request.maleParentName && this.request.maleParentName.type === MatchType.CONTAINS
            || this.request.groupSourceName && this.request.groupSourceName.type === MatchType.CONTAINS
            || this.request.immediateSourceName && this.request.immediateSourceName.type === MatchType.CONTAINS;
    }

    resetTable() {
        this.page = 1;
        this.previousPage = 1;
        this.isSelectAllPages = false;
        this.selectedItems = [];
        this.loadAll(this.request);
    }

    toggleAdditionalColumn(isVisible: boolean, columnPropertyId: string) {
        this.resultSearch.searchResultDbId = '';
        this.colVisPopOver.close();
        if (isVisible) {
            this.request.addedColumnsPropertyIds.push(columnPropertyId);
        } else {
            this.request.addedColumnsPropertyIds = this.request.addedColumnsPropertyIds.filter((e) => e !== columnPropertyId);
        }
        this.preSortCheck();
        this.resetTable();
    }

    private onSuccess(data, headers, callback) {
        this.filteredItems = headers.get('X-Filtered-Count');
        this.germplasmList = data;
        if (callback && typeof callback === 'function') {
            callback();
        }
    }

    isSelected(germplasm: Germplasm) {
        return germplasm && this.selectedItems.length > 0 && this.selectedItems.includes(germplasm.gid);
    }

    onSelectPage() {
        const isPageSelected = this.isPageSelected();
        const pageGids = this.germplasmList.map((germplasm) => germplasm.gid);
        if (isPageSelected) {
            this.selectedItems = this.selectedItems.filter((item) =>
                pageGids.indexOf(item) === -1);
        } else {
            this.selectedItems = pageGids.filter((item) =>
                this.selectedItems.indexOf(item) === -1
            ).concat(this.selectedItems);
        }
    }

    onSelectAllPages(isSelectAllPages) {
        this.isSelectAllPages = !isSelectAllPages;
        this.selectedItems = [];
    }

    toggleSelect($event, index, germplasm: Germplasm, checkbox = false) {
        if (this.isSelectAllPages) {
            return;
        }
        if (!$event.ctrlKey && !$event.metaKey && !checkbox) {
            this.selectedItems = [];
        }

        let items;
        if ($event.shiftKey) {
            const max = Math.max(this.lastClickIndex, index) + 1,
                min = Math.min(this.lastClickIndex, index);
            items = this.germplasmList.slice(min, max);
        } else {
            items = [germplasm];
            this.lastClickIndex = index;
        }
        const isClickedItemSelected = this.selectedItems.includes(germplasm.gid);
        for (const item of items) {
            if (this.selectedItems.length > 0 && isClickedItemSelected) {
                this.selectedItems = this.selectedItems.filter((item) => item !== germplasm.gid);
            } else if (!this.selectMultiple) {
                this.selectedItems = [item.gid];
            } else {
                this.selectedItems.push(item.gid);
            }
        }
    }

    isPageSelected() {
        return this.germplasmList.length > 0 && !this.germplasmList.some((germplasm) => this.selectedItems.indexOf(germplasm.gid) === -1);
    }

    /**
     * Filter by different fields.
     * - Some filters may have a custom filtering logic
     * - Will clear all existing filters
     * @param filterBy map with key value filters
     */
    private filterBy(filterBy: { [p: string]: any }) {
        if (!filterBy) {
            return;
        }
        const entries = Object.entries(filterBy);
        if (entries.length === 0) {
            return;
        }
        this.resetFilters();
    }

    private resetFilters() {
        this.filters = GermplasmSelectorComponent.getInitialFilters();
        this.request = new GermplasmSearchRequest();
        this.resultSearch = new SearchResult('');
    }

    selectGermplasm() {
        if (this.isSelectAllPages) {
            this.handleSelectAllPages();
        } else {
            this.handleGidSelection();
        }

    }

    handleSelectAllPages() {
        this.itemsPerPage = this.filteredItems;
        this.page = 1;

        this.loadAll(this.request, () => {
            this.selectedItems = this.germplasmList.map((germplasm) => germplasm.gid);
            this.handleGidSelection();
        });
    }

    handleGidSelection() {
        // Handle selection when this page is loaded outside Angular.
        if ((<any>window.parent).onGidsSelected) {
            (<any>window.parent).onGidsSelected(this.selectedItems);
        }
        if ((<any>window.parent)) {
            (<any>window.parent).postMessage({ name: 'selector-changed', 'value': this.selectedItems }, '*');
        }
    }

    cancel() {
        // Handle closing of modal when this page is loaded outside of Angular.
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
        if ((<any>window.parent)) {
            (<any>window.parent).postMessage({ name: 'cancel', 'value': '' }, '*');
        }
    }

    showProgenitorNamesColumn() {
        return this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSION) && this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION);
    }

    showNamesColumn() {
        return this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION) && this.germplasmList[0];
    }

    protected readonly preventDefaultOnShiftKey = preventDefaultOnShiftKey;
}
